// extracted by mini-css-extract-plugin
export default {"root":"UserForm_root__ReDRg","fullWidth":"UserForm_fullWidth__vmXci"};